export default __webpack_public_path__ + "static/media/moodTracker.a5006416.png";